import React, {Fragment, useEffect, useState} from "react";
import {CSSTransition, TransitionGroup} from "react-transition-group";
import {Card, CardBody, Col, Row} from "reactstrap";
import List from "Pages/Admin/Logging/List";

import PageHeading from "Layout/AppMain/PageHeading";


const Default = () => {
   
    return (
        <Fragment>
            <PageHeading/>
            <TransitionGroup>
                <CSSTransition component="div" classNames="TabsAnimation" appear={true}
                               timeout={1500} enter={false} exit={false}>
                    <div>
                        <Row>
                            <Col md="12">
                                <Card className="main-card mb-3">
                                    <CardBody className="p-3">
                                        <List />
                                    </CardBody>
                                </Card>
                            </Col>
                        </Row>
                    </div>
                </CSSTransition>
            </TransitionGroup>
        </Fragment>
    )
};

export default Default;